import angular from 'angular';

import { BursonServiceAjs }               from './burson.service.ajs';
import { BursonSettingsCtrl }             from './burson.settings.ajs';
import { BursonStates }                   from './burson.states.ajs';
import { ResolveBursonOrderFailuresCtrl } from './burson.order.resolve-failures.ajs';

angular.module('workshop.burson', [])
  .config(BursonStates)
  .controller('BursonSettingsCtrl', BursonSettingsCtrl)
  .controller('ResolveBursonOrderFailuresCtrl', ResolveBursonOrderFailuresCtrl)
  .service('bursonApi', BursonServiceAjs);
